// 单科报告

const ExamReportSingleLayout = r => require(['@/v3/modules/report/views/single/layout'], r)
const ExamReportSingleTranscriptLayout = r => require(['@/v3/modules/report/views/single/class/layout'], r)
const ExamReportClassBasic = r => require(['@/v3/modules/report/views/single/class/basic'], r)
const ExamReportClassAbility = r => require(['@/v3/modules/report/views/single/class/ability'], r)
const ExamReportClassAnalysis = r => require(['@/v3/modules/report/views/single/class/analysis'], r)
const ExamReportClassComment = r => require(['@/v3/modules/report/views/single/class/comment'], r)

const ExamReportPaperQuality = r => require(['@/v3/modules/report/views/paper-quality'], r)
const ExamReportClassTranscript = r => require(['@/v3/modules/report/views/single/class/transcript'], r)
const ExamReportClassProblemSet = r => require(['@/v3/modules/report/views/single/class/problemSet'], r)
const ExamReportClassTranscriptBasic = r => require(['@/v3/modules/report/views/single/class/transcriptBasic'], r)
const ExamReportClassTranscriptMistakes = r => require(['@/v3/modules/report/views/single/class/transcriptMistakes'], r)

const ExamReportGradeBasic = r => require(['@/v3/modules/report/views/single/grade/basic'], r)
const ExamReportGradeAbility = r => require(['@/v3/modules/report/views/single/grade/ability'], r)
const ExamReportGradeComment = r => require(['@/v3/modules/report/views/single/grade/comment'], r)
const ExamReportGradeCommentEdit = r => require(['@/v3/modules/report/views/single/grade/commentEdit'], r)
const ExamReportGradeCustomLayout = r => require(['@/v3/modules/report/views/single/grade/customLayout'], r)
const ExamReportGradeCustomGroup = r => require(['@/v3/modules/report/views/single/grade/customGroup'], r)
const ExamReportGradeCustomContrast = r => require(['@/v3/modules/report/views/single/grade/customContrast'], r)
const ExamReportGradeTranscript = r => require(['@/v3/modules/report/views/single/grade/transcript'], r)
const ExamReportGradeProblemSet = r => require(['@/v3/modules/report/views/single/grade/problemSet'], r)
const QuestionList = r => require(['@/v3/modules/report/views/single/class/similarRecom/questionList'], r)
const EditOnline = r => require(['@/v3/modules/report/views/single/class/similarRecom/editOnline'], r)
const ExamReportCustomKnowModel = r => require(['@/v3/modules/report/views/single/components/customKnowModel'], r)


export default [
  {
    path: '/exam/single/report/',
    component: ExamReportSingleLayout,
    children: [
      {
        path: '/exam/single/report/class/basic/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportClassBasic,
        name: 'examine-classReport-basic',
      },
      {
        path: '/exam/single/report/class/comment/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportClassComment,
        name: 'examine-classReport-comment',
      },
      {
        path: '/exam/single/report/class/ability/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportClassAbility,
        name: 'examine-classReport-ability',
      },
      {
        path: '/exam/single/report/class/analysis/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportClassAnalysis,
        name: 'examine-classReport-analysis',
      },
      {
        path: '/exam/single/report/class/transcript/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportClassTranscript,
        name: 'examine-classReport-transcript',
      },
      {
        path: '/exam/single/report/class/problemSet/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportClassProblemSet,
        name: 'examine-classReport-problemSet',
      },
      {
        path: '/exam/single/report/class/custom/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportCustomKnowModel,
        name: 'examine-classReport-custom',
      },
      {
        path: '/exam/single/report/class/quality/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportPaperQuality,
        name: 'examine-classReport-quality',
      },
      {
        path: '/exam/single/report/grade/basic/:id',
        meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
        component: ExamReportGradeBasic,
        name: 'examine-gradeReport-basic',
      },
      {
        path: '/exam/single/report/grade/comment/:id',
        meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
        component: ExamReportGradeComment,
        name: 'examine-gradeReport-comment',
      },
      {
        path: '/exam/single/report/grade/ability/:id',
        meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
        component: ExamReportGradeAbility,
        name: 'examine-gradeReport-ability',
      },
      {
        path: '/exam/single/report/grade/transcript/:id',
        meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
        component: ExamReportGradeTranscript,
        name: 'examine-gradeReport-transcript',
      },
      {
        path: '/exam/single/report/grade/problemSet/:id',
        meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
        component: ExamReportGradeProblemSet,
        name: 'examine-gradeReport-problemSet',
      },
      {
        path: '/exam/single/report/grade/custom/:id',
        meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
        component: ExamReportGradeCustomLayout,
        redirect: '/exam/single/report/grade/custom/:id/customGroup',
        children: [
          {
            path: '/exam/single/report/grade/custom/:id/customGroup',
            component: ExamReportGradeCustomGroup,
            meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
            name: 'examine-gradeReport-custom-customGroup',
          },
          {
            path: '/exam/single/report/grade/custom/:id/customContrast',
            meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
            component: ExamReportGradeCustomContrast,
            name: 'examine-gradeReport-custom-customContrast',
          }, {
            path: '/exam/single/report/grade/custom/:id/customKnowModel',
            meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
            component: ExamReportCustomKnowModel,
            name: 'examine-gradeReport-custom-customKnowModel',
          },
        ]
      },
      {
        path: '/exam/single/report/grade/quality/:id',
        meta: { auth: 'Exam-Single' },
        component: ExamReportPaperQuality,
        name: 'examine-classReport-quality',
      }
    ]
  },
  {
    path: '/exam/single/report/class/transcript/:examId/:classId/:studentId',
    component: ExamReportSingleTranscriptLayout,
    redirect: '/exam/single/report/class/transcript/:examId/:classId/:studentId/transcriptBasic',
    children: [
      {
        path: '/exam/single/report/class/transcript/:examId/:classId/:studentId/transcriptBasic',
        meta: { auth: 'Exam-Single' },
        component: ExamReportClassTranscriptBasic,
        name: 'examine-classReport-transcript-transcriptBasic',
      },
      {
        path: '/exam/single/report/class/transcript/:examId/:classId/:studentId/transcriptMistakes',
        component: ExamReportClassTranscriptMistakes,
        meta: { auth: 'Exam-Single' },
        name: 'examine-classReport-transcript-transcriptMistakes',
      }]
  },
  {
    path: '/exam/single/report/grade/comment/:id/:classId/:questionId/:type/edit',
    component: ExamReportGradeCommentEdit,
    meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
    name: 'examine-gradeReport-comment-edit',
  },
  {
    path: '/exam/single/report/similar_recom/list/:examId',
    component: QuestionList,
    meta: { auth: 'Exam-Single' },
    name: 'examine-classReport-similar-recom'
  },
  {
    path: '/exam/single/report/similar_recom/editonline/:examId',
    component: EditOnline,
    meta: { auth: 'Exam-Single' },
    name: 'examine-classReport-similar-recom'
  }
]
